/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useUser from '../../hooks/useUser'

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const user = useUser();
  const isAdmin = user.isAdmin;
  const isLoggedIn = user.isLoggedIn;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (props.location.pathname === '/admin' && !isAdmin)
          throw new Error();
        if (isLoggedIn === true)
          return <Component {...props} />;
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                from: props.location,
              },
            }}
          />
        );
      }}
    />
  );

}

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default ProtectedRoute;
